export default {
  'secure_iframe_loading': 'Loading secure embed...',
  'secure_iframe_error_title': 'Failed to load the embedded page',
  'secure_iframe_error_logged_out': 'Your session has expired. Please go back to the main site and sign in again.',
  'secure_iframe_error_no_permission': 'You do not have permission to access this page.',
  'secure_iframe_error_not_found': 'The embedded resource could not be found or is not configured for public embedding.',
  'secure_iframe_error_internal': 'Something went wrong. Please refresh and try again.',
  'secure_iframe_retry_btn': 'Retry',
};
